import { ReactNode } from 'react';

interface PageHeaderProps {
  title: string | ReactNode;
  actions?: ReactNode;
  controls?: ReactNode;
}

export function PageHeader({ title, actions, controls }: PageHeaderProps) {
  return (
    <header className="hidden lg:block border border-border bg-sidebar fixed top-0 right-0 left-[340px] z-[1000] h-[140px] rounded-[24px] mx-6 mt-6 shadow-[0_8px_28px_rgba(0,0,0,0.06)]">
      <div className="px-10 h-full flex flex-col justify-center gap-4">
        {/* Top Row: Title and Actions */}
        <div className="flex items-center justify-between gap-8">
          {/* Left side: Title */}
          <div className="flex-shrink-0">
            <h2 className="text-[22px] tracking-[-0.02em] text-foreground font-semibold">{title}</h2>
          </div>

          {/* Right side: Action Buttons */}
          {actions && (
            <div className="flex items-center gap-3 flex-shrink-0">
              {actions}
            </div>
          )}
        </div>

        {/* Bottom Row: Controls */}
        {controls && (
          <div className="flex items-center gap-4">
            {controls}
          </div>
        )}
      </div>
    </header>
  );
}